import './BuzzerDisplay.css';

import React, { useCallback, useEffect, useState } from 'react';

import Vegas from './Vegas';

const BuzzerDisplay = ({ teamName, backgroundColor }) => {
    const [animate, setAnimate] = useState(false);


    useEffect(() => {
        if (teamName) {
            setAnimate(true);
            const timer = setTimeout(() => setAnimate(false), 1500);
            return () => clearTimeout(timer);
        }
    }, [teamName]);


    const getBackgroundColorClass = useCallback(() => {
        switch (backgroundColor) {
            case 'powerbi':
                return 'powerbi-background';
            case 'fabric':
                return 'fabric-background';
            default:
                return '';
        }
    }, [backgroundColor]);

    return (
        <div className={`buzzer-container ${getBackgroundColorClass()}`}>
            {teamName ? (
                <h1 className={`team-name ${animate ? 'animate' : ''}`}>
                    {teamName}
                </h1>
            ) : (
                <Vegas />
            )}
        </div>
    );
};

export default BuzzerDisplay;
